import { useEffect, useState } from 'react';

import { CookieService } from '@/Module/Core/Service';

const useRubikaUser = () => {
  const [isRubikaUser, setIsRubikaUser] = useState<boolean>(false);

  useEffect(() => {
    const checkToken = () => {
      const rubikaToken = CookieService.getRubikaToken();
      setIsRubikaUser(!!rubikaToken);
    };

    checkToken();

    window.addEventListener('storage', checkToken);

    return () => {
      window.removeEventListener('storage', checkToken);
    };
  }, []);

  return isRubikaUser;
};

export { useRubikaUser };
